export interface BidMassiveItem {
  auctionId: number;
  bidInterestRate: number;
}

export interface BidMassiveRequest {
  fundId: number;
  transactionPassword?: string;
  items: BidMassiveItem[];
}

/**
 * Outcome of a single auction inside a massive bid batch.
 * `item` holds the auction id the result refers to.
 */
export interface BidMassiveResult {
  item: number;
  success: boolean;
  errorMessage?: string;
}

/** Batch size enforced by the backend: over this limit no bid is placed at all. */
export const MASSIVE_BID_MAX_BATCH_SIZE = 200;
